import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const ssoAPI = createApi({
  reducerPath: 'ssoAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AUTH_API_URL,
  }),
  endpoints: (builder) => ({
    getTenantInfoBySlug: builder.query({
      query: (tenantSlug) => `tenants/getInfo/${tenantSlug}`,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTenantInfoBySlugQuery } = ssoAPI
